import { useAltScrub } from './use-scrub-alt.js';
import { usePointerScrub } from './use-scrub-pointer.js';

function useScrub(ctx) {
    const [pointerScrubbing, getPointerScrubProps, Cursor] = usePointerScrub(ctx);
    const [wheelScrubbing, altScrubProps] = useAltScrub(ctx);
    return {
        scrubbing: pointerScrubbing || wheelScrubbing,
        getScrubProps: (...props) => getPointerScrubProps(altScrubProps, { 'data-fpl-scrub-disabled': ctx.disabled || undefined }, ...props),
        Cursor,
    };
}

export { useScrub };
//# sourceMappingURL=use-scrub.js.map
